<template>
  <div class="main">
    <Header
      :show="true"
      title="访客"
      left="prepage"
      :click-left="handleClickLeft"
    />
    <div style="padding-bottom: 8vh">
      <van-notice-bar
        left-icon="info-o"
        color="#ed6a0c"
        background="#FFFBE8"
        text="预约需要提取您的个人信息，请您放心我们将严格保护"
      />
      <van-form
        ref="order"
        @submit="submit"
      >
        <van-field
          style="display: none"
          name="checkboxGroup"
          label="访问区域"
          required
          :rules="[{ required: true }]"
        >
          <template #input>
            <van-checkbox-group
              v-model="areaTemp"
              direction="horizontal"
              @change="handleChangeArea"
            >
              <van-checkbox
                v-for="item in areaList"
                :key="item.id"
                v-model="item.value"
                :name="item.id"
                icon-size="18px"
                shape="square"
              >
                {{ item.name }}
              </van-checkbox>
            </van-checkbox-group>
          </template>
        </van-field>
        <van-field
          name="人脸照片"
          label="人脸照片"
          required
          :rules="[{ required: true, message: '人脸照片不能为空' }]"
        >
          <template #input>
            <van-uploader
              v-model="listQuery.photo"
              :max-count="1"
              :before-read="beforeRead"
              :after-read="afterRead"
            />
          </template>
        </van-field>
        <van-field
          v-model.trim="listQuery.name"
          name="姓名"
          label="姓名"
          placeholder="请输入您的姓名"
          :maxlength="20"
          :required="true"
          :rules="[
            { required: true, message: '请输入您的姓名' },
            {
              validator: validName,
              message: '请输入两字以上的姓名，仅支持中文',
            },
          ]"
        />
        <van-field
          v-model="listQuery.phone"
          name="手机号码"
          label="手机号码"
          placeholder="请输入手机号码"
          :required="true"
          type="number"
          :maxlength="11"
          :rules="[
            {
              required: true,
              message: '请输入手机号',
            },
            {
              validator: validMobilePhone,
              message: '手机号不正确',
            },
          ]"
        />
        <van-field
          v-model="listQuery.reason"
          rows="2"
          autosize
          label="访问事由"
          :required="true"
          type="textarea"
          maxlength="100"
          placeholder="请输入访问事由"
          show-word-limit
          :rules="[{ required: true, message: '访问事由不能为空' }]"
        />
        <van-field
          readonly
          clickable
          name="picker"
          :value="listQuery.start"
          label="开始日期"
          placeholder="点击选择开始日期"
          required
          @click="start.show = true"
        />
        <van-calendar
          v-model="start.show"
          :show-confirm="false"
          @confirm="handleConfirmStartDate"
        />
        <van-field
          readonly
          clickable
          name="picker"
          :value="listQuery.end"
          label="截止日期"
          placeholder="点击选择截止日期"
          required
          @click="end.show = true"
        />
        <van-calendar
          v-model="end.show"
          :show-confirm="false"
          @confirm="handleConfirmEndDate"
        />
        <div style="margin: 16px">
          <van-button
            round
            block
            type="info"
            :disabled="waiting"
            @click="handleConfirm"
          >
            确定
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import * as imageConversion from "image-conversion";
import { parseTime } from "@/utils";
import Header from "@/views/components/header/index.vue";
import { showPhoneAlarm } from "@/global/function.js";
import { isPhone, isChinese } from "@/utils/validate";
import { extCreateManOrderInfo } from "@/api/order.js";

export default {
  name: "DashboardOrderMan",
  components: {
    Header,
  },
  props: {},
  data() {
    const EDate = parseTime(new Date(), "{y}/{m}/{d}");
    const SDate = EDate;
    return {
      loading: false,
      waiting: false,
      listQuery: {
        name: "",
        phone: "",
        area: 1,
        photo: [],
        file: null,
        reason: "",
        start: SDate,
        end: EDate,
        stay: 1,
        validEnable: 0,
      },
      start: {
        show: false,
      },
      end: {
        show: false,
      },
      areaTemp: [0],
      areaList: [
        {
          id: 0,
          name: "办公区",
          value: false,
        },
        {
          id: 1,
          name: "生产区",
          value: false,
        },
      ],
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    handleClickLeft() {
      this.$router.push({ path: "/dashboard/reserve", query: {} });
    },
    handleChangeArea(value) {
      this.listQuery.area = 0;
      if (value.indexOf(0) !== -1 && value.indexOf(1) !== -1) {
        this.listQuery.area = 3;
      } else if (value.indexOf(0) !== -1) {
        this.listQuery.area = 1;
      } else if (value.indexOf(1) !== -1) {
        this.listQuery.area = 2;
      }
    },
    validName(value) {
      return new Promise((resolve) => {
        const result = isChinese(value, 2, 20);
        if (result === true) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    },
    validMobilePhone(value) {
      return new Promise((resolve, reject) => {
        const result = isPhone(value);
        if (result === true) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth();
      const day = date.getDate();
      return `${year}/${month + 1 > 9 ? month + 1 : "0" + (month + 1)}/${
        day > 9 ? day : "0" + day
      }`;
    },
    handleConfirmStartDate(date) {
      this.listQuery.start = this.formatDate(date);

      const start = new Date(this.listQuery.start).getTime() / 1000;
      const end = new Date(this.listQuery.end).getTime() / 1000;
      this.listQuery.stay = (end - start) / (3600 * 24) + 1;

      this.start.show = false;
    },
    handleConfirmEndDate(date) {
      this.listQuery.end = this.formatDate(date);

      const start = new Date(this.listQuery.start).getTime() / 1000;
      const end = new Date(this.listQuery.end).getTime() / 1000;
      this.listQuery.stay = (end - start) / (3600 * 24) + 1;

      this.end.show = false;
    },
    beforeRead(file) {
      const allowType = ["image/png", "image/jpeg"];
      if (!allowType.includes(file.type)) {
        this.$toast("请上传jpg/png格式图片");
        return false;
      }
      return true;
    },
    afterRead(file) {
      return new Promise((resolve, reject) => {
        let isLt2M = file.file.size / 1024 / 1024 < 0.2; // 判定图片大小是否小于4MB
        if (isLt2M) {
          this.listQuery.file = file.file;
          resolve(file);
        }
        const scale = parseFloat(
          1 / (file.file.size / 1024 / 1024 / 0.2)
        ).toFixed(2);
        imageConversion
          .compressAccurately(file.file, {
            size: 180,
            // scale: scale,
            width: 640,
          })
          .then((res) => {
            this.listQuery.file = res;
            resolve(res);
          });
      });
    },
    handleConfirm() {
      this.$refs.order.submit();
    },
    submit() {
      if (this.listQuery.area === 0) {
        showPhoneAlarm(true, "toast", null, 2000, 300, null, "请选择访问区域");
        return;
      }
      if (this.listQuery.stay <= 0) {
        showPhoneAlarm(
          true,
          "toast",
          null,
          2000,
          300,
          null,
          "截止日期须大于起始日期"
        );
        return;
      }
      this.waiting = true;
      let data = new FormData();
      data.append("name", this.listQuery.name);
      data.append("phone", this.listQuery.phone);
      data.append("gate", this.listQuery.area);
      data.append("image", this.listQuery.file);
      data.append("reason", this.listQuery.reason);
      data.append("startDate", new Date(this.listQuery.start).getTime());
      data.append("endDate", new Date(this.listQuery.end).getTime());
      data.append("validEnable", this.listQuery.validEnable);

      extCreateManOrderInfo(data)
        .then((response) => {
          const { data } = response;
          let message = data.message;
          if (data.message === null || data.message === "") {
            message = "预约成功";
          }
          if (
            showPhoneAlarm(
              true,
              "toast",
              null,
              2000,
              data.code,
              "预约",
              message
            )
          ) {
            this.$router.push({ path: "/dashboard/reserve", query: {} });
          }
        })
        .finally(() => {
          this.waiting = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
// 系统样式修改
::v-deep .van-field__label {
  width: 5em;
}
::v-deep .van-checkbox {
  padding: 3px 0;
}
::v-deep .van-checkbox__icon {
  font-size: 4.5vw;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F8F8F8;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
</style>
